class CollectionGridNew extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.isLoading = false;
    this.defaultCollectionHandle = this.dataset.defaultCollectionHandle;
    this.slides = this.querySelectorAll('.collection-grid-new__slide');
    this.optionPicker = this.querySelector('.option-picker');
    this.optionPickerBtn = this.querySelector('.option-picker-btn');
    this.optionPickerList = this.querySelector('.option-picker-list');
    this.defaultFilterTypes = this.dataset.filter;
    this.currentFilterTypes = {};
    this.selectedOptions = [];
    this.customCardsIndexes = [0, 7, 9, 14, 16, 21, 27, 29, 32];
    this.customCards = [];
    this.activeCollectionHandle = this.defaultCollectionHandle;
    this.dalstrongLoaderElement = `
      <div class="collection-grid-new-loading-bg">
        <div class="animating-logo-wrapper" data-image-src="${ this.dataset.loaderImageUrl }"></div>
      </div>
    `;
    this.pageSize = 52;
    this.filteredProducts = [];
    this.currentPage = 1;
  }

  connectedCallback() {
    this.initSwiper();
    this.setupEventListeners();
    this.fetchCollectionProducts();
  }

  setupEventListeners() {
    this.slides.forEach(slide => {
      slide.addEventListener('click', (e) => {
        if (e.currentTarget.classList.contains('active')) return;

        this.slides.forEach(s => s.classList.remove('active'));
        slide.classList.add('active');
        // Clear filter types and selected options when switching tabs
        this.optionPickerList.innerHTML = '';
        this.selectedOptions = [];
        this.fetchCollectionProducts();
      });
    });

    // Add click outside handler
    this.addEventListener('click', (event) => {
      const listContainer = this.querySelector('.option-picker-list-container');
      const isClickInsideList = listContainer?.contains(event.target);
      const isClickOnButton = this.optionPickerBtn.contains(event.target);

      if (isClickOnButton && !this.optionPicker.classList.contains('active')) {
        return this.optionPicker.classList.add('active');
      }
      
      if (
        event.target.closest('.option-picker-close') ||
        (!isClickInsideList && !isClickOnButton && this.optionPicker.classList.contains('active'))
      ) {
        this.optionPicker.classList.remove('active');
      }
    });

    this.optionPickerList.addEventListener('click', (event) => {
      const item = event.target.closest('.option-picker-list-sub-item');
      if (item) {
        event.preventDefault();
        event.stopPropagation();
        const checkbox = item.querySelector('.custom-checkbox');
        checkbox.classList.toggle('checked');
        this.updateSelectedOptions(item);
      }
    });
  }

  getSaleInfo(productPrice, productCollections) {
    let scriptSale = false;
    let scriptSavedAmount = null;

    const price = parseFloat(productPrice);
    if (isNaN(price)) return { scriptSale, scriptSavedAmount };
  
    // Define discount mappings
    const discountMapping = {
      "Cookware | 50%OFF": 0.5,
      "50%": 0.5,
      "60%": 0.6,
      "40%": 0.4,
      "30%": 0.3,
      "25%": 0.25,
      "20%": 0.2,
      "15%": 0.15,
      "10%": 0.1,
      "14%": 0.14285,
      "16%": 0.16667,
      "13%": 0.130438,
      "7.5%": 0.075,
      "19%" : 0.19093,
      "28%": 0.28653,
      "5%": 0.05
    };
  
    // Iterate through product collections
    for (const collection of productCollections) {
      for (const [key, discount] of Object.entries(discountMapping)) {
        if (collection.includes(key)) {
          scriptSavedAmount = price * discount;
          scriptSale = true;
          return { scriptSale, scriptSavedAmount }; // Stop looping once a match is found
        }
      }
    }
  
    return { scriptSale, scriptSavedAmount };
  }

  renderProducts(products, append = false) {
    let productGrid = this.querySelector('.product-grid');
    if (!productGrid) {
      productGrid = document.createElement('div');
      productGrid.className = 'product-grid';
      const optionPicker = this.querySelector('.option-picker');
      if (optionPicker) {
        optionPicker.after(productGrid);
      } else {
        this.appendChild(productGrid);
      }
    }
    
    if (!append) {
      productGrid.innerHTML = '';
    }

    // Update collection info
    const activeSlide = this.querySelector('.collection-grid-new__slide.active');
    const collectionTitle = activeSlide?.querySelector('.collection-grid-new__subtitle')?.textContent?.trim() || '';
    const collectionTitleElement = this.querySelector('.collection-title');
    const collectionCounterElement = this.querySelector('.collection-counter');
    
    if (collectionTitleElement) {
      collectionTitleElement.textContent = collectionTitle;
    }

    // Add loading element to product grid
    productGrid.insertAdjacentHTML('beforeend', this.dalstrongLoaderElement);
    this.dalstrongLoader = productGrid.querySelector('.collection-grid-new-loading-bg');

    // Show loading element before rendering products
    if (this.dalstrongLoader) {
      this.dalstrongLoader.classList.add('active');
      const logoWrapper = this.dalstrongLoader.querySelector('.animating-logo-wrapper');
      if (logoWrapper) {
        logoWrapper.insertAdjacentHTML('beforeend', `
          <img 
            src="${logoWrapper.dataset.imageSrc}"
            alt="Animated logo loader"
            width="100"
            height="88"
          />
        `);
      }
    }

    products.forEach(({ node }, index) => {
      // Insert custom card if this index matches
      if (this.customCardsIndexes.includes(index) && this.customCards.length > 0) {
        const customCard = this.customCards.shift();
        if (customCard) {
          productGrid.insertBefore(customCard, productGrid.children[index]);
        }
      }

      const title = node.title || '';
      const parts = title.split(' | ');

      const productName = parts[0];
      const series = parts.find(part =>
        /series|edition/i.test(part)
      ) || parts.find(part => part.includes('Dalstrong')) || '';
      const variantId = node.variants.edges[0].node.id.split('/').pop();
      
      // Get image from metafields or fallback to featured image
      let imageUrl = '';
      if (node.metafield?.reference?.image?.url) {
        imageUrl = node.metafield.reference.image.url;
      } else {
        imageUrl = node.featuredImage?.url || node.images?.edges[0]?.node.url || '';
      }

      const price = parseFloat(node.priceRange.minVariantPrice.amount);
      const compareAtPrice = parseFloat(node.compareAtPriceRange.maxVariantPrice.amount);
      const currency = node.priceRange.minVariantPrice.currencyCode;
      const isSoldOut = !node.availableForSale;
      const isNew = node.tags.includes('new');
      const hasBundleSave = node.tags.includes('bundle-save');
      const isBestSeller = node.tags.includes('BEST_SELLER');
      const hasBonusSheath = node.tags.includes('abs_sheath') || node.tags.includes('nylon_sheath') || node.tags.includes('leather_sheath') || node.tags.includes('wood_sheath') || node.tags.includes('bonus_sheath');
      const isNetflixBadge = node.tags.includes('Netflix_badge');
      const netflixBadgeUrl = this.dataset.netflixBadge;
      
      // Get collection titles for sale info
      const collectionTitles = node.collections.edges.map(edge => edge.node.title);
      const { scriptSale, scriptSavedAmount } = this.getSaleInfo(price, collectionTitles);
      const isLimitedTimeDeal = scriptSale;
      const discountPercentage = scriptSale ? Math.round((scriptSavedAmount / price) * 100) : 0;
      const hasCompareAtPrice = compareAtPrice > price;
      const discountedPrice = scriptSale ? (price - scriptSavedAmount) : price;

      const productCard = document.createElement('div');
      productCard.className = 'grid__item';
      productCard.innerHTML = `
        <div class="grid-product__content">
          <div class="badge-overlay">
            ${isNew && !isSoldOut && !isLimitedTimeDeal && !isNetflixBadge ? '<div class="badge--new grid-product__tag--new">NEW</div>' : ''}
            ${isSoldOut ? '<div class="badge--new grid-product__tag--sold-out">SOLD OUT</div>' : ''}
            ${isBestSeller && !isNew && !isLimitedTimeDeal && !isSoldOut && !isNetflixBadge ? '<div class="badge--new grid-product__tag--best-seller">BEST SELLER</div>' : ''}
            ${hasBonusSheath && !isBestSeller && !isLimitedTimeDeal && !isSoldOut && !isNew && !isNetflixBadge ? '<div class="badge--new grid-product__tag--sheath">BONUS SHEATH</div>' : ''}
            ${isLimitedTimeDeal && !isSoldOut ? '<div class="badge--new grid-product__tag--limited-time-deal">LIMITED TIME DEAL</div>' : ''}
            ${isNetflixBadge && !isLimitedTimeDeal ? `<img src="${netflixBadgeUrl}" alt="Netflix badge" loading="lazy" class="badge--netflix">` : ''}
          </div>
          <div class="collection-product-wrapper">
            <div class="grid-product__image-mask">
              <div">
                <a href="${node.onlineStoreUrl}"">
                  <img class="grid-product__image" src="${imageUrl}" alt="${node.title}" loading="lazy">
                </a>
              </div>
            </div>
            <div class="collection-product__info-wrapper">
              <div class="product-container__description">
                <a href="${node.onlineStoreUrl}" class="grid-product__link">
                  <div class="collection-product__title">
                    <div class="collection-product__collection-title">${series || ''}</div>
                    <div class="collection-product__product-title">${productName}</div>
                  </div>
                </a>
              </div>
              <div class="collection-product__button-container">
                <div class="grid-collection-product__price ${scriptSale || hasCompareAtPrice ? 'script-sale-price' : ''}">
                  ${scriptSale ? `<span class="home-discount-percentage">-${discountPercentage}%</span>` : ''}
                  <span class="igPrice" data-variant-id="${variantId}">${discountedPrice.toLocaleString('en-US', { style: 'currency', currency: currency })}</span>
                  ${scriptSale ? `<span class="home-card-discount" data-variant-id="${variantId}">${price.toLocaleString('en-US', { style: 'currency', currency: currency })}</span>` : ''}
                  ${!scriptSale && hasCompareAtPrice ? `<span class="home-card-discount" data-variant-id="${variantId}">${compareAtPrice.toLocaleString('en-US', { style: 'currency', currency: currency })}</span>` : ''}
                </div>
                ${hasBundleSave ? '<div class="coll_bundle_save">Bundle & Save</div>' : ''}
                <button 
                  class="add-to-cart btn--full" 
                  data-native-pre-order-btn
                  data-starting-variant="${variantId}"
                  data-variant-id="${variantId}"
                  ${isSoldOut ? 'disabled' : ''}
                >
                  ${isSoldOut ? 'Sold Out' : 'Add to Cart'}
                </button>
              </div>
            </div>
            <a href="${node.onlineStoreUrl}" class="whole-card__link"></a>
          </div>
        </div>
      `;

      productGrid.appendChild(productCard);

      // Add event listener to the add to cart button
      const addToCartButton = productCard.querySelector('.add-to-cart');
      if (addToCartButton && !isSoldOut) {
        addToCartButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1
              }]
            })
          })
          .then(response => response.json())
          .then(data => {
            document.dispatchEvent(new CustomEvent('cart:build', { detail: { openDrawer: true } }));
          })
          .catch(error => {
            console.error('Error adding item to cart:', error);
          });
        });
      }
    });
    
    // Update the counter after all products are appended
    if (collectionCounterElement) {
      collectionCounterElement.textContent = `(${this.filteredProducts.length} results)`;
    }

    // Remove loading element after products are rendered
    setTimeout(() => {
      if (this.dalstrongLoader) {
        this.dalstrongLoader.classList.remove('active');
        const logoWrapper = this.dalstrongLoader.querySelector('.animating-logo-wrapper');
        if (logoWrapper) {
          logoWrapper.innerHTML = '';
        }
      }
    }, 500);
  }

  prepareCustomProductCardsData(cards) {
    this.customCards = [];
    if (!cards?.length) {
      return;
    }

    cards.forEach((card, index) => {
      if (!card || !card.fields) {
        return;
      }

      // Find the product field in the metaobject
      const productField = card.fields.find(field => field.key === 'product');
      if (!productField?.reference) {
        return;
      }

      // Find the media file field in the metaobject
      const mediaField = card.fields.find(field => field.key === 'media_file');
      let imageUrl = '';
      
      if (mediaField?.reference?.image?.url) {
        imageUrl = mediaField.reference.image.url;
      } else {
        // Fallback to product's featured image
        imageUrl = productField.reference.featuredImage?.url || '';
      }

      const descriptionField = card.fields.find(field => field.key === 'description');
      const description = descriptionField?.value || '';

      const product = productField.reference;
      const title = product.title || '';
      const parts = title.split(' | ');

      const productName = parts[0];
      const series = parts.find(part =>
        /series|edition/i.test(part)
      ) || parts.find(part => part.includes('Dalstrong')) || '';
      const variantId = product.variants.edges[0].node.id.split('/').pop();

      const cardElement = document.createElement('div');
      cardElement.className = index === 0 ? 'grid__item custom-product-card width-2x' : 'grid__item custom-product-card';
      
      let cardHTML = index === 0 ? 
      `
        <div class="custom-product-card-image-container">
          <img class="custom-product-card-image" src="${imageUrl}" alt="${product.title}" loading="lazy">
        </div>
        <p class="custom-product-card-description">${description.split('\n').map(line => `<span>${line}</span><br>`).join('')}</p>
        <div class="custom-product-card-content desktop">
          <div class="custom-product-card-content-image-container">
            <img class="custom-product-card-content-image" src="${product.metafield?.reference?.image?.url || ''}" alt="${product.title}">
          </div>
          <div class="custom-product-card-content-text-container">
            <p class="custom-product-card-series-title">${series || ''}</p>
            <p class="custom-product-card-title">${productName}</p>
            <button class="custom-product-card-button" data-variant-id="${variantId}">ADD TO CART</button>
          </div>
        </div>
        <div class="custom-product-card-content mobile">
          <div class="custom-product-card-content-text-container">
            <div class="custom-product-card-titles-container">
              <p class="custom-product-card-series-title">${series || ''}</p>
              <p class="custom-product-card-title">${productName}</p>
            </div>
            <button class="custom-product-card-button" data-variant-id="${variantId}">ADD TO CART</button>
          </div>
        </div>
      `
      :
      `
        <div class="custom-product-card-image-container">
          <img class="custom-product-card-image" src="${imageUrl}" alt="${product.title}" loading="lazy">
        </div>
        <div class="custom-product-card-content">
          <p class="custom-product-card-series-title">${series || ''}</p>
          <p class="custom-product-card-title">${productName}</p>
        </div>
        <div class="custom-product-card-button-wrapper">
          <button class="custom-product-card-button" data-variant-id="${variantId}">ADD TO CART</button>
        </div>
      `;

      cardElement.innerHTML = cardHTML;
      
      // Add event listener to the add to cart button
      const addToCartButton = cardElement.querySelector('.custom-product-card-button');
      if (addToCartButton) {
        addToCartButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1
              }]
            })
          })
          .then(response => response.json())
          .then(data => {
            document.dispatchEvent(new CustomEvent('cart:build', { detail: { openDrawer: true } }));
          })
          .catch(error => {
            console.error('Error adding item to cart:', error);
          });
        });
      }
      
      this.customCards.push(cardElement);
    });
  }

  async fetchCollectionProducts() {
    if (this.slides) {
      this.slides.forEach(slide => {
        if (slide.classList.contains('active')) {
          this.activeCollectionHandle = slide.dataset.subcollectionHandle;
        }
      });
    }
  
    const query = `
      query getCollectionWithProducts($handle: String!, $cursor: String) {
        collection(handle: $handle) {
          id
          title
          description
          metafield(namespace: "custom", key: "filter_types") {
            value
            references(first: 50) {
              nodes {
                ... on Metaobject {
                  fields {
                    key
                    value
                  }
                }
              }
            }
          }
          customProductCards: metafield(namespace: "custom", key: "custom_card_products") {
            value
            references(first: 50) {
              nodes {
                ... on Metaobject {
                  id
                  type
                  fields {
                    key
                    value
                    reference {
                      ... on Product {
                        id
                        title
                        handle
                        onlineStoreUrl
                        availableForSale
                        featuredImage {
                          url
                          altText
                        }
                        metafield(namespace: "img", key: "card_image") {
                          value
                          reference {
                            ... on MediaImage {
                              image {
                                url
                                altText
                              }
                            }
                          }
                        }
                        variants(first: 1) {
                          edges {
                            node {
                              id
                            }
                          }
                        }
                      }
                      ... on MediaImage {
                        image {
                          url
                          altText
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          products(first: 250, after: $cursor) {
            pageInfo {
              hasNextPage
              endCursor
            }
            edges {
              node {
                id
                title
                handle
                onlineStoreUrl
                availableForSale
                featuredImage {
                  url
                  altText
                }
                metafield(namespace: "img", key: "card_image") {
                  value
                  reference {
                    ... on MediaImage {
                      image {
                        url
                        altText
                      }
                    }
                  }
                }
                priceRange {
                  minVariantPrice {
                    amount
                    currencyCode
                  }
                }
                compareAtPriceRange {
                  maxVariantPrice {
                    amount
                    currencyCode
                  }
                }
                variants(first: 1) {
                  edges {
                    node {
                      id
                      availableForSale
                      price {
                        amount
                        currencyCode
                      }
                      compareAtPrice {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
                tags
                collections(first: 100) {
                  edges {
                    node {
                      title
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;
  
    let allProductEdges = [];
    let hasNextPage = true;
    let cursor = null;
  
    try {
      while (hasNextPage) {
        const variables = {
          handle: this.activeCollectionHandle,
          cursor
        };
  
        const res = await fetch('https://dalstrong.co.uk/api/2024-01/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': '63ab0db8ff4077ce25a565739c33a207'
          },
          body: JSON.stringify({ query, variables })
        });
  
        const json = await res.json();
        if (json.errors) {
          console.error('GraphQL Errors:', json.errors);
          return;
        }
  
        const collection = json.data.collection;
        const productData = collection.products;
  
        allProductEdges.push(...productData.edges);
  
        hasNextPage = productData.pageInfo.hasNextPage;
        cursor = productData.pageInfo.endCursor;
        
        if (collection.metafield?.references?.nodes) {
          this.configureFilterTypes(allProductEdges, collection.metafield);
          this.renderFilterTypes();
        } else {
          if (this.defaultFilterTypes) {
            try {
              const filterTypesData = JSON.parse(this.defaultFilterTypes);
              // Convert section settings format to match metafield format
              const filterTypes = {
                references: {
                  nodes: filterTypesData.map(type => ({
                    fields: [
                      { key: 'title', value: type.title },
                      { key: 'options', value: JSON.stringify(type.options) }
                    ]
                  }))
                }
              };
              this.configureFilterTypes(allProductEdges, filterTypes);
              this.renderFilterTypes();
            } catch (e) {
              console.error('Error parsing filter types from section settings:', e);
              this.optionPickerList.innerHTML = '';
            }
          } else {
            this.optionPickerList.innerHTML = '';
          }
        }
        if (!this.customCardsPrepared && collection.customProductCards?.references?.nodes) {
          this.prepareCustomProductCardsData(collection.customProductCards.references.nodes);
          this.customCardsPrepared = true;
        }
      }
  
      // Save to session
      sessionStorage.setItem('allProducts', JSON.stringify(allProductEdges));
  
      // Final rendering
      this.filterAndRenderProducts();
    } catch (error) {
      console.error('Error fetching collection products:', error);
    }
  }  

  configureFilterTypes(collection, metafield) {
    // Get filter types from collection metafield references
    const filterTypeMetaobjects = metafield.references.nodes;
    
    // Reset current filter types
    this.currentFilterTypes = {};
    
    // Configure filter types based on metaobject data
    collection.forEach(product => {
      filterTypeMetaobjects.forEach(metaobject => {
        const titleField = metaobject.fields.find(field => field.key === 'title');
        const optionsField = metaobject.fields.find(field => field.key === 'options');
        
        if (titleField && optionsField) {
          const title = titleField.value;
          const options = JSON.parse(optionsField.value);
          
          options.forEach(option => {
            if (product.node.tags.includes(option)) {
              if (!Array.isArray(this.currentFilterTypes[title])) {
                this.currentFilterTypes[title] = [];
              }
              if (!this.currentFilterTypes[title].includes(option)) {
                this.currentFilterTypes[title].push(option);
              }
            }
          });
        }
      });
    });

    if (this.currentFilterTypes["Knife Length"]) {
      this.currentFilterTypes["Knife Length"].sort((a, b) => {
        return parseFloat(a) - parseFloat(b);
      });
    }
    if (this.currentFilterTypes["Cutting Board Size"]) {
      this.currentFilterTypes["Cutting Board Size"].sort((a, b) => {
        return parseFloat(a) - parseFloat(b);
      });
    }
    if (this.currentFilterTypes["Honing Rod Length"]) {
      this.currentFilterTypes["Honing Rod Length"].sort((a, b) => {
        return parseFloat(a) - parseFloat(b);
      });
    }
    if (this.currentFilterTypes["Grit"]) {
      this.currentFilterTypes["Grit"].sort((a, b) => {
        return parseFloat(a) - parseFloat(b);
      });
    }
  }

  renderFilterTypes() {
    this.optionPickerList.innerHTML = '';
    const filterTypesEntries = Object.entries(this.currentFilterTypes);
    const filterTypesPrefixes = JSON.parse(this.dataset.filterTypesPrefixes || '{}');
    
    if(filterTypesEntries.length) {
      this.optionPickerBtn.classList.remove('hide');
      filterTypesEntries.forEach(([title, options]) => {
        const typeItem = document.createElement('li');
        typeItem.classList.add('option-picker-list-item');
        
        // Get the prefix for this filter type if it exists
        const prefix = filterTypesPrefixes[title] || '';
        
        typeItem.innerHTML = `
          <p class="option-picker-list-item-title">${title}</p>
          <ul class="option-picker-list-sub">
            ${options.map(option => {
              // Remove the prefix from the option if it exists
              const displayOption = prefix && option.startsWith(prefix) 
                ? option.replace(prefix, '') 
                : option;
              return `
                <li class="option-picker-list-sub-item">
                  <div class="custom-checkbox"></div>
                  <p data-option-tag='${option}'>${displayOption}</p>
                </li>
              `;
            }).join('')}
          </ul>
        `;
        this.optionPickerList.appendChild(typeItem);
      });
    } else {
      this.optionPickerBtn.classList.add('hide');
    }
  }

  filterAndRenderProducts() {
    if (this.dalstrongLoader) {
      this.dalstrongLoader.classList.add('active');
      const logoWrapper = this.dalstrongLoader.querySelector('.animating-logo-wrapper');
      if (logoWrapper) {
        logoWrapper.insertAdjacentHTML('beforeend', `
          <img 
            src="${logoWrapper.dataset.imageSrc}"
            alt="Animated logo loader"
            width="100"
            height="88"
          />
        `);
      }
    }

    const allProducts = JSON.parse(sessionStorage.getItem('allProducts')) || [];
    let filteredProducts = [];
    if (this.selectedOptions.length === 0) {
      filteredProducts = [...allProducts].sort((a, b) => {
        if (a.node.availableForSale && !b.node.availableForSale) return -1;
        if (!a.node.availableForSale && b.node.availableForSale) return 1;
        return 0;
      });
    } else {
      const groupedOptions = {};
      this.selectedOptions.forEach(option => {
        Object.entries(this.currentFilterTypes).forEach(([type, options]) => {
          if (options.includes(option)) {
            if (!groupedOptions[type]) {
              groupedOptions[type] = [];
            }
            groupedOptions[type].push(option);
          }
        });
      });
      filteredProducts = allProducts
        .filter(({ node }) => {
          return Object.entries(groupedOptions).every(([type, options]) => {
            return options.some(option => {
              return node.tags.includes(option);
            });
          });
        })
        .sort((a, b) => {
          if (a.node.availableForSale && !b.node.availableForSale) return -1;
          if (!a.node.availableForSale && b.node.availableForSale) return 1;
          return 0;
        });
    }

    this.filteredProducts = filteredProducts;
    this.currentPage = 1;
    const paginatedProducts = this.filteredProducts.slice(0, this.pageSize);

    this.renderProducts(paginatedProducts, false);
    this.renderPaginationControls(this.filteredProducts.length);
  }
  
  updateSelectedOptions(item) {
    const option = item.querySelector('p').dataset.optionTag;
    if (this.selectedOptions.includes(option)) {
      this.selectedOptions = this.selectedOptions.filter(o => o !== option);
    } else {
      this.selectedOptions.push(option);
    }

    this.filterAndRenderProducts();
  }

  initSwiper() {
    const swiperElement = this.querySelector('.swiper');
    if (!swiperElement) return;

    this.swiper = new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 30,
      grabCursor: 'true',
      mousewheel: {
        enabled: true
      },
      breakpoints: {
        320: {
          spaceBetween: 20
        },
        769: {
          spaceBetween: 30
        }
      }
    });
  }

  renderPaginationControls(totalProducts) {
    let paginationContainer = this.querySelector('.collection-pagination');
    if (!paginationContainer) {
      paginationContainer = document.createElement('div');
      paginationContainer.className = 'collection-pagination';
      this.appendChild(paginationContainer);
    }
    paginationContainer.innerHTML = '';

    const displayedCount = Math.min(this.currentPage * this.pageSize, totalProducts);
    const startIndex = totalProducts > 0 ? 1 : 0;
    const endIndex = displayedCount;
    if (totalProducts === 0) {
      paginationContainer.style.display = 'none';
      return;
    }
    paginationContainer.style.display = '';

    const rangeText = document.createElement('div');
    rangeText.className = 'collection-pagination-range';
    rangeText.textContent = `${startIndex} - ${endIndex} of ${totalProducts} PRODUCTS`;
    paginationContainer.appendChild(rangeText);

    if (endIndex < totalProducts) {
      const loadMoreBtn = document.createElement('button');
      loadMoreBtn.className = 'collection-pagination-load-more';
      loadMoreBtn.textContent = 'LOAD MORE';
      loadMoreBtn.addEventListener('click', () => {
        this.currentPage += 1;
        const start = (this.currentPage - 1) * this.pageSize;
        const end = Math.min(start + this.pageSize, totalProducts);
        const nextProducts = this.filteredProducts.slice(start, end);
        this.renderProducts(nextProducts, true); // append only next page
        this.renderPaginationControls(totalProducts);
      });
      paginationContainer.appendChild(loadMoreBtn);
    }
  }
}

customElements.define('collection-grid-new', CollectionGridNew);
